<template>
  <b-navbar toggleable="lg" type="light" variant="white">
    <b-container>
      <b-navbar-brand class="w-50 mt-3 mb-3">
        <img src="@/assets/images/ecomedica.png"
             style=" image-rendering: crisp-edges!important;"
             class="img-fluid img-shadow-ligth w-md-30 w-100"
             alt="">
      </b-navbar-brand>
      <b-navbar-toggle v-if="false"
          target="nav-collapse"
          class="w-25">
        <i class="fa-solid text-white fa-bars"></i>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse"  v-if="false"
                  :class="{'menu-navbar-mobile shadow-blur':$isMobile()}" is-nav>
        <b-navbar-nav>
          <b-nav-item class="px-xl-3 px-1 mt-md-0 mt-3"
                      @click="to('acerca')">
            <i class="fa-solid text-primary fa-address-card"></i>
            <span class="font-weight-bolder">
              Acerca de nosotros
            </span>
          </b-nav-item>
          <b-nav-item class="px-xl-3 px-1 mt-md-0 mt-3"
                      @click="to('servicios')">
            <i class="fa-solid text-primary fa-briefcase"></i>
            <span class="font-weight-bolder">
              Nuestros servicios
            </span>
          </b-nav-item>
          <b-nav-item class="px-xl-3 px-1 mt-md-0 mt-3"
                      @click="to('contacto')">
            <i class="fa-solid text-primary fa-envelope"></i>
            <span class="font-weight-bolder">
              Contacto
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: "navbar"
}
</script>

<style scoped>

</style>